import { RenderersUIType } from "@home-health-notify/domain";
import {
  and,
  ControlProps,
  RankedTester,
  rankWith,
  schemaTypeIs,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import { FormDetailItem } from "../../messageType/contentType/FormContent.style";

const DataLabelRenderer = ({ data }: ControlProps) => {
  return <FormDetailItem>{data} :</FormDetailItem>;
};

export const dataLabelTester: RankedTester = rankWith(
  5,
  and(uiTypeIs(RenderersUIType.DataLabel), schemaTypeIs("string")),
);

export default withJsonFormsControlProps(DataLabelRenderer);
